export default{
    drOrClinic : 'دکتر/کلینیک',
    fertilityDate  : 'تاریخ اقدام',
    ivf  : 'نوع اقدام',
    iui  : 'IUI',
    io  : 'IO',
    pgd  : 'PGD',
    pgdDescription  : 'توضیحات PGD',
    pgs  : 'PGS',
    pgsDescription  : 'توضیحات PGS',
    eggsCount:'تعداد تخمک',
    numberOfFetuses:'تعداد جنین',
    gradeOfEmbryo:'گرید جنین',
    typeOfTransferOperation:'نوع عمل انتقال',
    description:'توضیحات',
    resultTransferOperationType:'نتیجه عمل انتقال',
}